import { useContext, useCallback } from "react";
import Card from "./Card";
import { DeckPositionContext } from "./DeckPositionContext";

interface DeckPileProps {
  remaining: number;
}

export default function DeckPile({ remaining }: DeckPileProps) {
  const { registerDeck } = useContext(DeckPositionContext);
  const deckRefCallback = useCallback(
    (el: HTMLDivElement | null) => registerDeck(el),
    [registerDeck],
  );

  return (
    <div className="flex flex-col items-center gap-1">
      <div ref={deckRefCallback} className="relative">
        {remaining > 2 && (
          <div className="absolute -top-0.5 -left-0.5">
            <Card faceDown />
          </div>
        )}
        {remaining > 1 && (
          <div className="absolute -top-[1px] -left-[1px]">
            <Card faceDown />
          </div>
        )}
        <div className="relative">
          <Card faceDown />
        </div>
      </div>
      <span className="text-[10px] text-green-200 font-mono">
        {remaining} left
      </span>
    </div>
  );
}
